import React from 'react'
import { parseMarkdown } from 'web/utils/utils'
import classNames from 'classnames'

type Props = {
    categoryName: string
    fightName: string
    hideNote?: boolean
    fightNoteHtml?: string
    className?: string
}

export const FightHeader: React.FC<Props> = (props) => {

    const showNote =
        (props.hideNote == null || props.hideNote === false) &&
        (props.fightNoteHtml != null && props.fightNoteHtml !== "")

    const note = props.fightNoteHtml ?? ''

    return (
        <div className={classNames(
            props.className,
            "d-flex flex-column",
        )}>

            <div className="small text-muted pb-1">
                {props.categoryName}
            </div>

            <h4 className="m-0">
                {props.fightName}
            </h4>

            {showNote &&
                <div
                    title="Fight note"
                    className="mt-1 mb-0 small text-muted markdown text-break"
                    dangerouslySetInnerHTML={{ __html: parseMarkdown(note) }}
                />
            }

        </div>
    )
}
